export default "__VITE_ASSET__C0Xyw_CW__"